import React from 'react';
import classnames from 'classnames';
import { css } from '@emotion/css';
import { useIntl } from '@/i18n';

const styles = {
  container: css`
    display: flex;
    border: 1px solid rgb(214, 214, 214);
    border-radius: 4px;
    padding: 20px 16px 20px 16px;
  `,
  icon: css`
    font-size: 20px;
    margin-right: 10px;
    color: #adadad;
  `,
};

const PendingFrame = () => {
  const { t } = useIntl();
  return (
    <div className={styles.container}>
      <i className={classnames('is24-icon-time', styles.icon)} />
      <p>
        {t({
          id: 'benefits.deposit.modal.overview.pendingText',
          defaultMessage:
            'Dein Antrag ist bei der Allianz in der Bearbeitung. Dies nimmt gewöhnlich einen Werktag in Anspruch.',
        })}
      </p>
    </div>
  );
};

export default PendingFrame;
